// 新品建档-基本属性模块公用js
const itemBaseMixins = {
  props:{
    paramList:{
      type:Object,
      required:true,
    },
    itemFormSon:{
      type:String,
      required:false,
    }
  },
  data(){
    return{
      source:'',
      itemappId:'',
      item:'',
    }
  },
  methods: {
    //保存-基本信息
    save(filtersName,num){
      if(num == '2' || num == '3'){
        if(this.isAdd && this.item == ''){
          this.$message.error(`请先保存基本信息！`);
          return false;
        }
      }
      let _this = this;
      this.filters.itemappId = this.itemappId;
      this.filters.lastUpdateId = this.$getUserId();
      this.filters.submitterOwner = this.$getUserId();
      this.$refs[filtersName].validate(valid => {
        if(this.isAdd && this.itemFormSon == ''){
            if (valid) {
              this.$api.newproduct.insertAppItemmasterBaseinfo(this.filters).then(res => {
                if (res && res.data.code == "0" && res.data.msg =='success') {
                  let result = res.data.result;
                  let item = result.item;
                  this.filters.item = item;
                  if(num == '1'){
                    let param = {
                      item : this.filters.item,
                      dept: this.filters.dept,
                    }
                    _this.$emit('getItemId',param);
                  }
                  this.$message({message: "保存成功！",type: "success"});
                  _this.getList(this.item);
                } else {
                  this.$message.error(`${res.data.msg}`);
                }
              });
            } else {
              this.$message({
                message: "请填写完整信息再保存",
                type: "error"
              });
              return false;
          }
        }else if(this.isEdit || (this.itemFormSon)){
          if (valid) {
            this.$api.newproduct.updateAppItemmasterBaseinfo(this.filters).then(res => {
              if (res && res.data.code == "0" && res.data.msg =='success') {
                  let result = res.data.result;
                  if(num == '1'){
                    let param = {
                      item : this.filters.item,
                      dept: this.filters.dept,
                    }
                    _this.$emit('getItemId',param);
                  }else if(num == '2'){
                    _this.$emit('getInventoryInd',this.filters.inventoryInd);
                  }
                  this.$message({message: "保存成功！", type: "success" });
                  _this.getList(this.item);
              } else {
                this.$message.error(`${res.data.msg}`);
              }
            });
          } else {
            this.$message({
              message: "请填写完整信息再保存",
              type: "error"
            });
            return false;
          }
        }
      });
    },
  },
  created(){
    this.source = this.paramList.source;
    this.itemappId = this.paramList.itemappId;
    this.item = this.itemFormSon;
    if(this.item){
      this.getList(this.item);
    }
    if(this.isAdd){
      this.deptDis=true;
      this.classDis = true;
      this.sclsDis = true;
    }
  },
  computed: {
    isLook(){
      return this.source=="detail";
    },
    isEdit(){
      return this.source=="edit";
    },
    isAdd(){
      return this.source=="add";
    },
  },
}
export default itemBaseMixins;


// WEBPACK FOOTER //
// ./src/mixins/ItemmasterBaseinfo.js